export class CompanyDiscounts {
}
//# sourceMappingURL=company-discounts.js.map